const GTM_ID = "GTM-PKSSQ465";

/** Loads Google Tag Manager once. Called only after analytics consent. */
export const loadGtm = (): void => {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  if (document.getElementById("rakb-gtm")) return;

  const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer ?? [];
  dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  (window as Window & { dataLayer?: unknown[] }).dataLayer = dataLayer;

  const script = document.createElement("script");
  script.id = "rakb-gtm";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  iframe.title = "Google Tag Manager";
  document.body.appendChild(iframe);
};
